import { Routes } from '@angular/router';
import { LoginSuccessComponent } from './auth/login-success/login-success';
import { Show } from './forms/show/show';
import { Success } from './forms/success/success';
import { Login } from './auth/login/login';
import { Dashboard } from './dashboard/dashboard';
import { authGuard } from './auth/auth.guard';
import { PendingChangesGuard } from './pending-changes.guard';

export const routes: Routes = [
  {
    path: 'auth/login',
    component: Login,
  },
  {
    path: 'login',
    component: LoginSuccessComponent,
  },
  {
    path: '',
    component: Dashboard,
    canActivate: [authGuard],
  },
  { path: 'forms/success', component: Success, canActivate: [authGuard] },
  {
    path: 'forms/:id/:stepId',
    component: Show,
    canActivate: [authGuard],
    canDeactivate: [PendingChangesGuard],
    // canDeactivate: [(component: Show) => component.canDeactivate()],
  },
  {
    path: 'forms/:id/:responseId/:stepId',
    component: Show,
    canActivate: [authGuard],
    canDeactivate: [PendingChangesGuard],
    // canDeactivate: [(component: Show) => component.canDeactivate()],
  },
  {
    path: 'forms/:id',
    redirectTo: 'forms/:id/1',
    pathMatch: 'full',
    // canDeactivate: [(component: Show) => component.canDeactivate()],
  },
];
